module.exports = __webpack_public_path__ + "static/circle_1-5e5419be87727d71f1528d27688ded3a.png";